// @ts-nocheck
'use client'

import { useState } from 'react'
import FarmingBlocksManagement from './FarmingBlocksManagement'
import GroupsManagement from './GroupsManagement'

const FarmingBlock = () => {
  const [blockGroups, setBlockGroups] = useState([])

  const handleBlockGroupsUpdate = (updatedBlockGroups) => {
    setBlockGroups(updatedBlockGroups)
  }

  return (
    <>
      {/* Farming Blocks Management Section */}
      <FarmingBlocksManagement
        blockGroups={blockGroups}
        onRefreshBlockGroups={handleBlockGroupsUpdate}
      />

      {/* Groups Management Section */}
      <GroupsManagement onBlockGroupsUpdate={handleBlockGroupsUpdate} />
    </>
  )
}

export default FarmingBlock
